import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="bg-brand-cream py-24 px-6" data-id="element-12">
      <div className="max-w-[620px] mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl border-2 border-brand-mint shadow-[0_8px_30px_rgba(0,0,0,0.08)] p-10 md:p-14 text-center relative overflow-hidden" data-id="element-14">
          {/* Subtle background pattern/glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-brand-mint/10 blur-2xl pointer-events-none" data-id="element-15"></div>

          <div className="text-6xl mb-6 relative z-10" data-id="element-16">🛡️</div>

          <h2 className="text-[2rem] md:text-[2.4rem] text-brand-darkgreen mb-6 leading-tight relative z-10" data-id="element-17">
            Comprá sin riesgo
          </h2>

          <p className="text-brand-gray text-lg leading-relaxed relative z-10" data-id="element-18">
            Si en 7 días no encontrás valor en la guía, te devolvemos el dinero.
            Sin preguntas, sin formularios, sin vueltas.
          </p>
        </motion.div>
      </div>
    </section>;
}